import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './Button';
import './States.css';

/**
 * ErrorState — запрос упал. Человеку — понятный текст и «Повторить»,
 * никаких кодов/стеков.
 *
 *   title    — «Не удалось загрузить отгрузки» (по умолчанию общий)
 *   message  — что случилось и что делать («Проверьте интернет и повторите»)
 *   onRetry  — кнопка «Повторить»
 *   compact  — строкой внутри таблицы/карточки
 */
export function ErrorState({ title, message = 'Произошла ошибка', onRetry, compact = false, className = '' }) {
  return (
    <div className={`ui-error ${compact ? 'ui-error--compact' : ''} ${className}`} role="alert">
      <AlertTriangle size={compact ? 18 : 36} className="ui-error__icon" aria-hidden="true" />
      {title && <p className="ui-error__title">{title}</p>}
      <p className="ui-error__msg">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" icon={RefreshCw} onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  );
}
